module.exports = {
  ColorsData: () => {
    return {
      "mg_zs_hybrid_2025" : 
      [
        {
          "id": "red",
          "name" : "Rojo",
          "icon": require('../assets/colors/mg_zs_hybrid_2025/fiery-red.webp'),
          "active" : true,
          "interactable" : true
        },
        {
          "id": "black",
          "name" : "Negro",
          "icon": require('../assets/colors/mg_zs_hybrid_2025/black-petrol.webp'),
          "active" : true,
          "interactable" : true
        },
        {
          "id": "blue",
          "name" : "Azúl",
          "icon": require('../assets/colors/mg_zs_hybrid_2025/dark-blue.webp'),
          "active" : true,
          "interactable" : true
        },
        {
          "id": "green",
          "name" : "Verde",
          "icon": require('../assets/colors/mg_zs_hybrid_2025/green-pearl.webp'),
          "active" : false,
          "interactable" : true
        },
        {
          "id": "grey",
          "name" : "Gris",
          "icon": require('../assets/colors/mg_zs_hybrid_2025/typhoon-grey.webp'),
          "active" : true,
          "interactable" : true
        },
        {
          "id": "silver",
          "name" : "Plata",
          "icon": require('../assets/colors/mg_zs_hybrid_2025/silver.webp'),
          "active" : true,
          "interactable" : true
        },
        {
          "id": "white",
          "name" : "Blanco",
          "icon": require('../assets/colors/mg_zs_hybrid_2025/atlas-white.webp'),
          "active" : true,
          "interactable" : true
        },
      ],
    }
  }
}